<template>
    <div class="StoreDetailsWrap">
        <div class="AddInvoice1 flex" v-if="axdzstate">
            <div class="AddWrap">
                <header class="flexa">
                    <i @click="Closeaxdz"><img src="../../assets/returns.png"/></i>
                    <p>按需求定制</p>
                </header>
                <div class="DeveloperWrap">
                    <div v-if="dzliststate">
                    <div class="ListDz" v-for="(item, index) in dzlistdata" :key="index">
                        <div class="flexbetween">
                            <p style="margin-bottom: 0">{{ item.联系人 }}</p>
                            <p style="margin-bottom: 0;font-size: 0.051rem">
                                {{ item.提交时间 }}
                            </p>
                        </div>
                        <div style="margin-top: 0.05rem">
                            <p style="opacity: 0.8;font-size: 0.05rem">
                                {{ item.联系方式 }}
                            </p>
                        </div>
                        <div>
                            <p style="opacity: 0.8;">
                                {{ item.需求说明 }}
                            </p>
                        </div>
                        <div class="Anwser">
                            <div class="flexbetween">
                                <p style="font-size: 0.049rem">回复:</p>
                                <p style="font-size: 0.049rem">
                                    {{ item.回复时间 ? item.回复时间 : "" }}
                                </p>
                            </div>
                            <p style="opacity: 0.8;">
                                {{ item.回复内容 ? item.回复内容 : "暂无回复，请耐心等待" }}
                            </p>
                        </div>
                    </div>
                    </div>
                    <div v-else>
                        <div class="InputWrap">
                            <div class="flexbetween">
              <span class="flex">联系人</span
              ><input style="user-select: auto" v-model="user" />
                            </div>
                            <div class="flexbetween">
              <span class="flex">联系电话</span
              ><input style="user-select: auto" v-model="phone" />
                            </div>
                            <div>
                                <p style="font-size: 0.051rem;color: #414141">具体需求</p>
                                <textarea
                                        style="user-select: auto;display:block;color:#414141;font-size:0.051rem;width: 91%;height: 0.6rem;background-color: #f5f5f5;margin-top: 0.05rem;border-radius: 0.05rem;padding: 0.1rem;box-sizing: border-box"
                                        placeholder="具体需求"
                                        v-model="text"
                                ></textarea>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="dzliststate" class="flexa" style="width: 100%;height: 0.3rem;position: relative"><div @click="Add" class="flex" style="width: 0.6rem;height: 0.2rem;color:#fff;background-color: #cc3333;font-size: 0.051rem;border-radius: 0.2rem;position: absolute;right: 0.15rem;cursor: pointer">新增</div></div>
                <div v-else class="flexa" style="width: 100%;height: 0.3rem;position: relative"><div @click="Submit" class="flex" style="width: 0.6rem;height: 0.2rem;color:#fff;background-color: #cc3333;font-size: 0.051rem;border-radius: 0.2rem;position: absolute;right: 0.15rem;cursor: pointer">提交</div></div>
            </div>
        </div>
        <div class="AddInvoice flex" v-if="builderstate">
        <div class="AddWrap">
            <header class="flexa">
                <i @click="CloseChoose"><img src="../../assets/returns.png"/></i>
                <p>开发者列表</p>
            </header>
            <div class="DeveloperWrap">
                <ul>
                    <li
                            class="flex"
                            v-for="(item, index) in PersonData"
                            :key="index"
                    >
                        <div class="Text">
                            <!--                <div class="Time">
                          <p>加入时间 {{ item.时间 }}</p>
                        </div>-->
                            <div class="Name">{{ item.名称 }}</div>
                            <div class="Do oneline">
                                {{ item.标签 ? item.标签.split(",")[0] : "" }}
                            </div>
                            <div
                                    class="Star flex"
                                    :class="{ Active: item.选择标识 }"
                                    @click="ChoosePerson(item, $event)"
                            >
                                <p v-if="item.选择标识">已选择</p>
                                <p v-else>选择</p>
                            </div>
                        </div>
                        <div class="Icon">
                            <img v-if="item.logo图" :src="item.logo图" />
                            <img v-else src="../../assets/defaulthead.png" />
                        </div>
                    </li>
                </ul>
            </div>
            <div class="flexa" style="width: 100%;height: 0.3rem;position: relative"><div @click="Ok" class="flex" style="width: 0.6rem;height: 0.2rem;color:#fff;background-color: #cc3333;font-size: 0.051rem;border-radius: 0.2rem;position: absolute;right: 0.15rem;cursor: pointer">确定</div></div>
        </div>
        </div>
        <div class="LineCut flexbetween">
            <div class="NewsTitle flexa"><p>定制服务</p></div>
            <div class="Return flexa" @click="Return"><p>返回</p><img src="../../assets/Home/return.png"></div>
        </div>
        <div v-if="outflag" class="TabButton flexa">
            <div v-for="(item,index) in TabButtonData" :key="index" class="flexa" :class="{Active:index==flag}" @click="Tab(index)">
                <img :src="item.Icon">
                <p>{{item.Text}}</p>
            </div>
        </div>
        <!-- 定制产品详情 -->
        <div class="CustomizationBox Scroll" v-if="customboxstate">
            <Customization
                    :flag="flag"
                    @CloseCustomBox="CloseCustomBox"
                    @OpenChooseBox="OpenChooseBox"
                    @OpenLoginBox="OpenLoginBox"
                    :customdetailsdata="customdetailsdata"
                    :choosedperson="choosedperson"
                    :classid="'MN037870000000000000000001'"
            ></Customization>
        </div>
        <!-- 产品详情页 -->
        <div class="ProductDetails" v-if="productboxstate">
            <Productdetails
                    :flag="flag"
                    :titlename="'云平台'"
                    :productdetailsdata="productdetailsdata"
                    @CloseProductBox="CloseProductBox"
                    :classid="'MN037870000000000000000001'"
            ></Productdetails>
        </div>
        <div v-if="outflag" class="TabContentWrap clearfix">
            <ul>
                <li v-for="(item,index) in ProductData" :key="index" @click="ToDetails(item.产品ID)">
                    <div class="IconWrap">
                        <img :src="item.logo图">
                        <div class="Name"><p>{{ item.名称 }}</p></div>
                        <div class="flexa Items"><span>{{ item.标签 }}</span></div>
                    </div>
                    <div class="TextWrap">
                        <p class="sixline">{{ item.详情介绍 }}</p>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
  import { mapGetters } from 'vuex';
  import Productdetails from './ProductDetails';
  import Customization from '../../components/Customization';
  export default {
    name: 'storedetails',
    inject: [
      'load'
    ],
    components: {
      Productdetails,
      Customization
    },
    data() {
      return {
        flag: 0,
        phone: '',
        user: '',
        text: '',
        outflag: true,
        dzlistdata: [],
        axdzstate: false,
        dzliststate: true,
        customboxstate: false,
        productboxstate: false,
        builderstate: false,
        choosestate: false,
        ProductData: [],
        choosedperson: {},
        customdetailsdata: {},
        choosedpersonflag: {},
        PersonData: [],
        productdetailsdata: {
          basedata: {}
        },
        TabButtonData: [
          {
            Icon: require('../../assets/Buttonicon/button1.png'),
            Text: '云产品定制'
          },
          /*          {
            Icon: require('../../assets/Buttonicon/button2.png'),
            Text: '云平台定制'
          }, */
          {
            Icon: require('../../assets/Buttonicon/button3.png'),
            Text: '按需求定制'
          }
        ]
      };
    },
    created() {
      console.log(this.$route.params.id);
      if (this.$route.params.flag) {
        this.flag = this.$route.params.flag;
      }
      if (this.$route.params.id) {
        this.flag = 0;
        this.outflag = false;
        this.ToDetails(this.$route.params.id);
      } else if (
        this.$route.params.flag === 0 ||
        this.$route.params.flag === undefined
      ) {
        this.GetProductList('WBA0007005');
      } else if (this.$route.params.flag === 1) {
        this.GetProductList('WBA0007035');
      }
    },
    computed: {
      ...mapGetters(['LoginUserInfo', 'UserInfo', 'currentSystem'])
    },
    methods: {
      Submit() {
        if (this.user && this.phone && this.text) {
          this.load.show();
          this.$axios({
            method: 'POST',
            url: 'https://x6.goeasy.cn/cli/client/Web_OnClickButtonOfBill',
            data: {
              commandId: 'WBA0007030',
              buttonText: 'Verify',
              userId: 'GoeasyUser' + this.LoginUserInfo.userId,
              headData: {
                联系人: this.user,
                联系方式: this.phone,
                需求说明: this.text,
                用户ID: this.LoginUserInfo.goeasyid
              },
              saveGridData: 1
              /*   gridData: this.chooseitems */
            }
          })
            .then(res => {
              this.load.hide();
              if (res.data.code === 0) {
                console.log(res);
                this.GetDzListData(true);
                this.dzliststate = true;
                this.user = '';
                this.phone = '';
                this.text = '';
                this.$message.success('提交成功!请耐心等待回复');
              } else {
                this.$message.error(res.data.msg);
              }
            })
            .catch(error => {
              this.load.hide();
              this.$message.error(error);
              console.log(error);
            });
        } else {
          this.$message.warning('还有未填项');
        }
      },
      GetDzListData(isget) {
        this.load.show();
        this.$axios({
          method: 'POST',
          url: 'https://x6.goeasy.cn/cli/client/Web_GetCommandDatas',
          data: {
            commandId: 'WBA0007031',
            userId: 'GoeasyUser' + this.LoginUserInfo.userId
          }
        })
          .then(res => {
            if (res.data.code === 0) {
              this.axdzstate = true;
              if (isget) {
                this.dzlistdata = res.data.data.DETAIL;
              } else if (res.data.data.DETAIL.length > 0) {
                this.dzlistdata = res.data.data.DETAIL;
                this.dzliststate = true;
              } else {
                this.dzliststate = false;
              }
              console.log(res);
            } else {
              this.$message.error(res.data.msg);
            }
            this.load.hide();
          })
          .catch(error => {
            this.load.hide();
            this.$message.error(error);
            console.log(error);
          });
      },
      SubmitZc() {
        console.log('123');
      },
      Add() {
        this.dzliststate = false;
      },
      Closeaxdz() {
        if (this.dzliststate) {
          this.axdzstate = false;
        } else {
          this.dzliststate = true;
        }
      },
      OpenLoginBox() {
        this.$emit('OpenLoginBox');
      },
      CloseChoose() {
        this.builderstate = false;
      },
      ChoosePerson(item, e) {
        for (let i in this.PersonData) {
          this.PersonData[i].选择标识 = false;
        }
        item.选择标识 = true;
        this.choosedpersonflag = item;
        if (e) {
          e.stopPropagation();
        }
      },
      Ok() {
        this.builderstate = false;
        this.choosedperson = this.choosedpersonflag;
      },
      /* 获取开发者列表 */
      GetPersonList() {
        this.load.show();
        this.$axios({
          method: 'POST',
          url: 'https://x6.goeasy.cn/cli/client/Web_GetCommandDatas',
          data: {
            commandId: 'WBA0007007',
            userId: 'CommonUser_ixuOYxkPy78='
          }
        })
          .then(res => {
            if (res.data.code === 0) {
              console.log(res);
              this.PersonData = res.data.data.DETAIL;
              if (this.choosedperson.名称) {
                for (let i in this.PersonData) {
                  if (
                    this.choosedperson.开发者ID === this.PersonData[i].开发者ID
                  ) {
                    this.PersonData[i].选择标识 = true;
                    break;
                  }
                }
              }
              for (let i in this.PersonData) {
                this.PersonData[i].服务费 = this.$utils.accMul(
                  this.PersonData[i].服务费系数,
                  this.customdetailsdata.价格
                );
              }
              this.builderstate = true;
              console.log(this.PersonData);
            } else {
              this.$message.error(res.data.msg);
            }
            this.load.hide();
          })
          .catch(error => {
            this.load.hide();
            this.$message.error(error);
            console.log(error);
          });
      },
      OpenChooseBox() {
        this.GetPersonList();
      },
      CloseCustomBox() {
        if (this.outflag) {
          this.customboxstate = false;
        } else {
          this.$router.back();
        }
      },
      /* 获取定制详情 */
      GetCustomDetails(id) {
        this.load.show();
        this.$axios({
          method: 'POST',
          url: 'https://x6.goeasy.cn/cli/client/Web_GetCommandDatas',
          data: {
            commandId: 'WBA0007004',
            userId: 'CommonUser_ixuOYxkPy78=',
            filter: { 产品ID: id }
          }
        })
          .then(res => {
            if (res.data.code === 0) {
              console.log(res);
              this.load.hide();
              this.customdetailsdata = res.data.data.DETAIL[0];
              this.customboxstate = true;
              this.choosedperson = {};
            } else {
              this.load.hide();
              this.$message.error(res.data.msg);
            }
          })
          .catch(error => {
            this.load.hide();
            this.$message.error(error);
            console.log(error);
          });
      },
      /* 获取商品详情 */
      GetProducDetails(id) {
        this.load.show();
        this.$axios({
          method: 'POST',
          url: 'https://x6.goeasy.cn/cli/client/Web_GetCommandDatas',
          data: {
            commandId: 'WBA0007004',
            userId: 'CommonUser_ixuOYxkPy78=',
            filter: { 产品ID: id }
          }
        })
          .then(res => {
            if (res.data.code === 0) {
              console.log(res);
              this.productdetailsdata.basedata = res.data.data.DETAIL[0];
              this.GetMoreItemList(id);
            } else {
              this.$message.error(res.data.msg);
            }
          })
          .catch(error => {
            this.load.hide();
            this.$message.error(error);
            console.log(error);
          });
      },
      ToDetails(flag) {
        console.log('当前点击产品', flag);
        this.GetCustomDetails(flag);
      },
      CloseProductBox() {
        if (this.outflag) {
          this.productboxstate = false;
        } else {
          this.$router.back();
        }
      },
      /* 获取商品列表 */
      GetProductList(id) {
        this.load.show();
        this.$axios({
          method: 'POST',
          url: 'https://x6.goeasy.cn/cli/client/Web_GetCommandDatas',
          data: {
            commandId: id,
            userId: 'CommonUser_ixuOYxkPy78='
          }
        })
          .then(res => {
            if (res.data.code === 0) {
              console.log(res);
              this.ProductData = res.data.data.DETAIL;
            } else {
              this.$message.error(res.data.msg);
            }
            this.load.hide();
          })
          .catch(error => {
            this.load.hide();
            this.$message.error(error);
            console.log(error);
          });
      },
      Return() {
        this.$router.back();
      },
      Choose() {
        this.choosestate = !this.choosestate;
      },
      Tab(flag) {
        if (flag !== 1) {
          this.flag = flag;
        }
        if (flag === 0) {
          this.GetProductList('WBA0007005');
        } else if (flag === 1) {
          this.GetDzListData(false);
          /*    this.GetProductList('WBA0007035'); */
        } else {
          console.log('打开定制弹出层');
        }
      }
    }
  };
</script>
<style scoped lang="scss">
    @import '../../../public/Value';
    .StoreDetailsWrap{
        .AddInvoice1{
            width: 100%;
            height: 100%;
            background-color: rgba(0,0,0,0.6);
            position: fixed;
            left: 0;
            top: 0;
            z-index: 5;
            .InputWrap {
                width: 86%;
                margin: 0.1rem auto 0;
                div{
                    width: 100%;
                    margin-bottom: 0.1rem;
                    span {
                        font-size: $TextSize;
                        color: #414141;
                    }
                    input {
                        width: 1.5rem;
                        height: 0.18rem;
                        color: #414141;
                        background-color: #f5f5f5;
                        font-size: $TextSize;
                        text-indent: 0.08rem;
                        border-radius: 0.05rem;
                    }
                    input::placeholder{
                        font-size: $TextSize;
                    }
                }
                .tip {
                    margin-bottom: 0.08rem;
                    span {
                        font-size: $SmallTextSize;
                        color: rgba(65, 65, 65, 0.8);
                    }
                }
            }
            .DeveloperWrap {
                width: 100%;
                height: calc(100% - 0.7rem);
                overflow: scroll;
                overflow-scrolling: touch;
                margin-top: 0.05rem;
                &::-webkit-scrollbar {
                    display: none;
                }
                .Anwser {
                    width: 100%;
                    border-top: 1px solid #cdcdcd;
                    padding-top: 0.02rem;
                    p {
                        font-size: $AdditionTextSize;
                        margin-bottom: 0.02rem;
                    }
                }
                .ListDz {
                    width: 80%;
                    padding: 0.1rem;
                    box-sizing: border-box;
                    background: linear-gradient(to Right, #7a7a7a, #484848);
                    border-radius: 0.1rem;
                    margin: 0 auto 0.05rem;
                    p {
                        font-size: $TextSize;
                        margin-bottom: 0.05rem;
                        color: #fff;
                    }
                }
            }
            .AddWrap{
                width: 30%;
                height: calc(100% - 1rem);
                background-color: #fff;
                border-radius: 0.1rem;
                header {
                    width: 88%;
                    height: 0.2rem;
                    margin: 0 auto;
                    padding-top: 0.1rem;
                    position: relative;
                    i {
                        width: 0.1rem;
                        cursor: pointer;
                        img {
                            width: 100%;
                        }
                    }
                    p {
                        font-size: $SmallTitleSize;
                        color: #666666;
                        position: absolute;
                        right: 0;
                        font-weight: bold;
                    }
                }
            }
        }
        .AddInvoice{
            width: 100%;
            height: 100%;
            background-color: rgba(0,0,0,0.6);
            position: fixed;
            left: 0;
            top: 0;
            z-index: 5;
            .DeveloperWrap {
                width: 100%;
                height: calc(100% - 0.8rem);
                overflow: scroll;
                overflow-scrolling: touch;
                margin-top: 0.15rem;
                &::-webkit-scrollbar {
                    display: none;
                }
                ul {
                    width: 100%;
                    padding-bottom: 0.2rem;
                    li {
                        width: 85%;
                        height: 0.65rem;
                        border-radius: 0.1rem;
                        background: linear-gradient(to Right, #333333, #1b1b1b);
                        margin: 0 auto 0.1rem;
                        .Text {
                            width: 1.02rem;
                            margin-right: 0.2rem;
                            margin-left: 0.02rem;
                            .Time {
                                margin-bottom: 0.05rem;
                                p {
                                    font-size: $AdditionTextSize;
                                    opacity: 0.6;
                                    color: #fff;
                                }
                            }
                            .Star {
                                width: 0.5rem;
                                height: 0.15rem;
                                border-radius: 0.1rem;
                                background-color: #555555;
                                margin-top: 0.08rem;
                                cursor: pointer;
                                p {
                                    font-size: $TextSize;
                                    color: #fff;
                                }
                            }
                            .Active {
                                background-color: #ecb036;
                            }
                            .Name {
                                height: 0.1rem;
                                width: 0.7rem;
                                border-bottom: 2px solid #fff;
                                font-size: $AdditionTextSize;
                                color: #fff;
                                margin-bottom: 0.05rem;
                            }
                            .Do {
                                font-size: $SmallTextSize;
                                color: #fff;
                                opacity: 0.6;
                            }
                        }
                        .Icon {
                            width: 0.5rem;
                            height: 0.5rem;
                            img {
                                width: 100%;
                                height: 100%;
                                object-fit: cover;
                                border-radius: 0.1rem;
                            }
                        }
                    }
                }
            }
            .AddWrap{
                width: 30%;
                height: calc(100% - 1rem);
                background-color: #fff;
                border-radius: 0.1rem;
                header {
                    width: 88%;
                    height: 0.2rem;
                    margin: 0 auto;
                    padding-top: 0.1rem;
                    position: relative;
                    i {
                        width: 0.1rem;
                        cursor: pointer;
                        img {
                            width: 100%;
                        }
                    }
                    p {
                        font-size: $SmallTitleSize;
                        color: #666666;
                        position: absolute;
                        right: 0;
                        font-weight: bold;
                    }
                }
            }
        }
        width: 100%;
        position: relative;
        .ProductDetails,.CustomizationBox{
            width: 50%;
            height:calc(100% - 0.8rem);
            top:0.8rem;
            left: 25%;
            position: fixed;
            z-index: 4;
            background-color: #000;
            overflow-y: scroll;
            &::-webkit-scrollbar{
                display: none;
            }
        }
        .LineCut{
            width: 90%;
            margin: 0.05rem auto 0.05rem;
            border-bottom: 2px solid #fff;
            .Return{
                cursor: pointer;
                p{
                    font-size: $AdditionTextSize;
                    color: #fff;
                }
                img{
                    width: 0.05rem;
                    margin-left: 0.02rem;
                }
            }
            .NewsTitle{
                p{
                    font-size: $TitleSize;
                    color: #fff;
                    padding-bottom: 0.045rem;
                    span{
                        opacity: 0.6;
                        font-weight: normal;
                    }
                }
            }
        }
        .TabButton{
            width: 100%;
            height: 0.7rem;
            div{
                width: 0.82rem;
                height: 0.32rem;
                border-radius: 0.2rem;
                background-color: #cc3333;
                margin: 0 0.23rem;
                cursor: pointer;
                img{
                    width: 0.2rem;
                    margin:0 0.11rem 0 0.07rem;
                }
                p{
                    font-size: $TextSize;
                    color: #fff;
                }
            }
            div.Active{
                background-color: #cc6666;
            }
        }
        .TabContentWrap{
            width: 88%;
            margin: 0 auto;
            .Title {
                width: 100%;
                margin: 0 auto;
                position: relative;
                height: 0.3rem;
                margin-top: 0.1rem;
                p {
                    font-size: $TitleSize;
                    color: #fff;
                    position: absolute;
                    left: 0;
                    font-weight: bold;
                }
                i {
                    width: 0.1rem;
                    position: absolute;
                    right: 0;
                    cursor: pointer;
                    img {
                        width: 100%;
                    }
                }
            }
            ul{
                width: 100%;
                li{
                    width: 32%;
                    height: 1.3rem;
                    background-color: #fff;
                    border-radius: 0.1rem;
                    float: left;
                    margin-right: 2%;
                    margin-bottom: 2%;
                    position: relative;
                    cursor: pointer;
                    .Buttons{
                        width: 100%;
                        position: absolute;
                        bottom: 0.08rem;
                        left: 0;
                        div{
                            cursor: pointer;
                            p{
                                font-size: $AdditionTextSize;
                                color: #fff;
                            }
                        }
                        div:first-child{
                            width: 0.3rem;
                            height: 0.13rem;
                            border-radius: 0.4rem;
                            background-color: #8c73b5;
                            margin: 0 0.09rem;
                        }
                        div:last-child{
                            width: 0.48rem;
                            height: 0.13rem;
                            border-radius: 0.4rem;
                            background-color: #cc9933;
                        }
                    }
                    .TextWrap{
                        width: 82%;
                        margin: 0.1rem auto 0;
                        p{
                            font-size: $AdditionTextSize;
                            color: #414141;
                            line-height: 0.075rem;
                        }
                    }
                    .IconWrap{
                        margin: 0.1rem 0 0 0.1rem;
                        img{
                            width: 0.25rem;
                            border-radius: 0.05rem;
                        }
                        .Name{
                            margin: 0.03rem 0;
                            p{
                                font-size: $TextSize;
                                color: #000;
                                font-weight: bold;
                            }
                        }
                        .Items{
                            span{
                                font-size: $SmallTextSize;
                                color: #999999;
                                margin-right: 0.02rem;
                            }
                        }
                    }
                }
                li:nth-child(3n){
                    margin-right: 0;
                }
            }
        }
    }
</style>
